
export default {
  props: {
    cookies: Array,
    cookiename: String,
    expirationDays : String
  },

  data: () => {
    return {
      simpleForm: true,
      checkedCookies: [],

    }
  },

  created() {
    this.checkedCookies = this.cookies
  },

  mounted() {
    if (!this.cookieExists(this.cookiename)) {
      this.showModal()
    }
  },

  methods: {

    showModal() {
      $(this.$refs.modal).modal('show')
    },

    hideModal() {
      $(this.$refs.modal).modal('hide')
    },

    submitForm() {
      this.consentWithCookies()
      this.hideModal()
      location.reload();
    },

    toggleForm(){
      this.simpleForm = !this.simpleForm
    },

    cookieExists(name) {
      return (document.cookie.indexOf(name + '=') !== -1);
    },

    consentWithCookies() {
      this.setCookie(this.cookiename, this.cookie_value, this.expirationDays);
    },

    setCookie(name, value, expirationInDays) {
      var date = new Date();
      date.setTime(date.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
      // document.cookie = name + '=' + value + '; ' + 'expires=' + date.toUTCString() + ';path=/';
      document.cookie = name + '=' + this.checkedCookies + '; ' + 'expires=' + date.toUTCString() + ';path=/';
    },

    setUtmCookie(name, value, expirationInDays) {
      var date = new Date();
      date.setTime(date.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + value + '; ' + 'expires=' + date.toUTCString() + ';path=/';
    },

    getCheckedCookies(){
      return this.checkedCookies;
    }
  }
}

